module.exports = __webpack_public_path__ + "static/sport-8f6a3038ffa07e3dae898b5d664ea3df.jpg";